import React, { useEffect, useState } from "react";
import TopBar from "../../components/TopBar";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where
} from "firebase/firestore";
import { collectionNames } from "../../utils/Constants";
import { auth, db } from "../../utils/firebase";
import Button from "../../components/Button";
import AddNewSession from "./components/AddSessionModal";
import SessionItem from "./components/SessionItem";
import DBFilterBar from "./components/DBFilterNav";

const Dashboard = () => {
  const [sessions, setSessions] = useState([]);
  const [filteredSessions, setFilteredSessions] = useState([]);
  const [modals, setModals] = useState({});

  const createSession = async () => {
    const docRef = await addDoc(collection(db, collectionNames.SESSIONS), {
      userId: auth.currentUser.email,
      status: "active"
    })
      .then((doc) => {
        alert("Session created successfully.");
      })
      .catch((err) => {
        alert("Couldnt create session, Please try again");
      });
  };

  const getSessions = async () => {
    const q = query(
      collection(db, collectionNames.SESSIONS),
      where("userId", "==", auth.currentUser?.email),
      orderBy("timestamp", "desc")
    );

    const querySnapshot = await getDocs(q);
    let tmpSessions = [];

    querySnapshot.forEach((doc) => {
      if (doc.data()) {
        tmpSessions.push({ id: doc.id, ...doc.data() });
      }
    });
    setSessions(tmpSessions);
    setFilteredSessions(tmpSessions);
  };

  useEffect(() => {
    getSessions();
  }, []);

  return (
    <div>
      <TopBar
        hideBack
        title="Dashboard"
        endBtn={
          <Button
            label={"Create Session"}
            onClick={() => setModals((prev) => ({ ...prev, addSession: true }))}
          />
        }
      />
      <div className="mx-5">
        <DBFilterBar datas={sessions} setFilteredDatas={setFilteredSessions} />
      </div>

      <div className="flex  flex-wrap">
        {filteredSessions.map((session, idx) => (
          <SessionItem
            getSessions={getSessions}
            session={session}
            key={session.id}
            idx={idx}
          />
        ))}
      </div>

      {modals.addSession && (
        <AddNewSession
          getSessions={getSessions}
          onClose={() => setModals((prev) => ({ ...prev, addSession: false }))}
        />
      )}
    </div>
  );
};

export default Dashboard;
